module.exports = __webpack_public_path__ + "assets/img/picture6.ab6c15d6.svg";